// extracted by mini-css-extract-plugin
export var content = "post-content-module--content--c4f19";
export var date = "post-content-module--date--1087b";
export var title = "post-content-module--title--b9d34";